import type { Country } from '@tenders/shared';

/**
 * The deployment's country in English — what schema.org `areaServed` /
 * `spatialCoverage` names. The /plans JSON-LD said «Uzbekistan» on both
 * deployments, so kaztender.com told search engines its tariffs were for
 * Uzbekistan. Keyed by `Country`, so a new deployment does not compile until it
 * has a name here.
 */
const COUNTRY_NAME_EN: Record<Country, string> = {
  uz: 'Uzbekistan',
  kz: 'Kazakhstan',
  kg: 'Kyrgyzstan',
};

export function countryNameEn(code: Country): string {
  return COUNTRY_NAME_EN[code];
}
